import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import SlotFrame from './components/SlotFrame/SlotFrame'
import SlotsLayout from './components/SlotsLayout/SlotsLayout'
import { ROUTE_PATHS } from '../../router/routes'

export class SlotsModule {
  getRoutes() {
    return (
      <Route key="slots" path={ROUTE_PATHS.SLOTS}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route key={ROUTE_PATHS.SLOTS_PROVIDER} exact path={ROUTE_PATHS.SLOTS_PROVIDER} component={SlotFrame} />
            <Route
              key={ROUTE_PATHS.SLOTS_PROVIDER_DEMO_START}
              exact
              path={ROUTE_PATHS.SLOTS_PROVIDER_DEMO_START}
              component={SlotFrame}
            />
            <Route
              key={ROUTE_PATHS.SLOTS_PROVIDER_FREE_SPIN}
              exact
              path={ROUTE_PATHS.SLOTS_PROVIDER_FREE_SPIN}
              component={SlotFrame}
            />
            <Route exact path={ROUTE_PATHS.SLOTS_GAMETYPE}>
              <SlotsLayout />
            </Route>
            <Route exact path={ROUTE_PATHS.SLOTS}>
              <Redirect to={ROUTE_PATHS.SLOTS_CASINO} />
            </Route>
          </Switch>
        </QueryParamProvider>
      </Route>
    )
  }
}
